/* eslint-disable no-unused-expressions */

/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
// ES5 way
// exports.onClientEntry = () => {
// ES6 way
export const onClientEntry = () => {
  // This is broken, commented out instead of bashing my fucking skull anymore
  // IntersectionObserver polyfill for gatsby-background-image (Safari, IE)

  if (window && !window.IntersectionObserver) {
    import(`intersection-observer`)
    console.log(`# IntersectionObserver is polyfilled!`)
  }
}
